<template>
    <div class="topicIndex spackage padding-20 bgc box-shadow">
        <!-- start 顶部菜单栏 -->
        <section class="startMgt-header">
            <el-button type="primary" align="left" @click="goto('CreateData')">新建资料</el-button>
            <div align="right" style="float:right;display: flex">
                <el-date-picker class="item" v-model="time.date" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
                <el-select v-model="integralValue" placeholder="帖子种类">
                    <el-option v-for="item in integral" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
                <el-input placeholder="输入关键字" v-model="searchName" style="width: 240px"></el-input>
                <el-button type="primary" @click="handleQuery" plain>搜索</el-button>
            </div>
        </section>
        <!-- end 顶部菜单栏 -->
        <section>
            <el-table :data="StartInfoData">
                <el-table-column prop="customername" label="用户名称" align="center" width="200px">
                    <template slot-scope="scope">
                        <div class="customerBox">
                            <img :src="scope.row.customerlogo">
                            <span :show-overflow-tooltip="true" class="recommon">{{scope.row.customername}}</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="content" label="内容" align="center"></el-table-column>
                <el-table-column prop="viewcount" label="浏览量" align="center" width="100"></el-table-column>
                <el-table-column prop="commentcount" label="评论数" align="center" width="100"></el-table-column>
                <el-table-column prop="praisecount" label="点赞数" align="center" width="100"></el-table-column>
                <el-table-column prop="datetime" label="发布时间" align="center" width="160"></el-table-column>
                <el-table-column label="操作" align="right" class-name="table-position">
                    <template slot-scope="scope">
                        <span @click="jumpDetails('DataDetails',scope.row.innerid)">详情</span>
                        <span>｜</span>
                        <el-dropdown>
                              <span class="el-dropdown-link">
                                更多
                              </span>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item><span @click="istopClick(scope.row.innerid,scope.row.istop)">{{scope.row.istop=='0'?'置顶':'取消置顶'}}</span></el-dropdown-item>
                                <el-dropdown-item><span @click="isgoodClick(scope.row.innerid,scope.row.isgood)">{{scope.row.isgood=='0'?'加精':'取消加精'}}</span></el-dropdown-item>
                                <el-dropdown-item><span @click="delClick(scope.row.innerid)">删除</span></el-dropdown-item>
                                <el-dropdown-item><span @click="priseClick(scope.row.innerid)">马甲点赞</span></el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </template>
                </el-table-column>
            </el-table>
            <page :total="total" ref="page" @getList="searchClick"></page>
        </section>
    </div>
</template>

<script>
    import {getStartInfoList,infoIstop,infoIsgood,infoDel,vestPraise} from '@/api/communityApi'
    import Loading from 'base/loading/loading' // 引入 loading 组件
    import {mapGetters,mapActions} from 'vuex'
    import Page from 'base/page/page'
    import fecha from 'element-ui/src/utils/date';
    export default {
        name: "index",
        data() {
            return {
                innerid: this.$route.query.innerid,
                value1: '', //日期
                integralValue: '',
                integral: [
                    {
                        value: '',
                        label: '全部种类'
                    },
                    {
                        value: '1',
                        label: '置顶'
                    }, {
                        value: '2',
                        label: '加精'
                    }],
                StartInfoData:[], //列表数据
                total:0,
                time: {             // 开始/结束时间
                    date: ''
                },
                searchName:'' //搜索文字
            }
        },
        components: {
            Loading,
            Page
        },
        mounted() {
            this.setLoading(true);
            this.apiData = {
                starid:this.$route.query.innerid,
                page: 1,
                pageSize: 10
            };
            this.startInfoEvent()
        },
        methods: {
            goto(href,starid) {
                this.$router.push({name: href,query:{'innerid':this.innerid,'starid':starid}})
            },
            jumpDetails(href,id){
                this.$router.push({name: href,query:{'innerid':id,'starid':this.innerid,'datatype':2}})
            },
            handleQuery() {
                this.$refs.page.handleSizeChange(1)
            },
            ...mapActions([
                'setLoading'
            ]),
            //星球资料列表
            startInfoEvent() {
                getStartInfoList({
                    data: this.apiData,
                    success: data => {
                        console.log(data);
                        this.setLoading(false);
                        this.StartInfoData = data.data.content;
                        this.total = data.data.pageinfo.rowCount
                    },
                    error: data => {
                        this.setLoading(false)
                    }
                })
            },
            // 置顶
            istopClick(id,type){
                let params = {
                    innerid: id,
                    istop: type == '0' ? '1' : '0',
                };
                this.setLoading(true);
                infoIstop({
                    data: Object.assign({}, params),
                    success: data => {
                        this.setLoading(false);
                        this.startInfoEvent();
                        this.$message({
                            message: '设置成功',
                            type: 'success'
                        });
                    },
                    error: data => {
                        this.setLoading(false);
                        console.log('error：', data)
                    }
                })
            },
            //加精
            isgoodClick(id,type){
                let params = {
                    innerid: id,
                    isgood: type == '0' ? '1' : '0',
                };
                this.setLoading(true);
                infoIsgood({
                    data: Object.assign({}, params),
                    success: data => {
                        this.setLoading(false);
                        this.startInfoEvent();
                        this.$message({
                            message: '设置成功',
                            type: 'success'
                        });
                    },
                    error: data => {
                        this.setLoading(false);
                        console.log('error：', data)
                    }
                })
            },
            // 删除
            delClick(id) {
                this.$confirm('删除后将不可恢复，确认删除吗？', '删除', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消'
                }).then(() => {
                    let params = {
                        innerid: id,
                        status: 100,
                    };
                    this.setLoading(true);
                    infoDel({
                        data: Object.assign({}, params),
                        success: data => {
                            this.setLoading(false);
                            this.startInfoEvent();
                            this.$message.success(`删除成功!`)
                        },
                        error: data => {
                            this.setLoading(false);
                            console.log('error：', data)
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    })
                })
            },
            // 马甲点赞
            priseClick(id){
                let params = {
                    innerid: id,
                    datatype: 2
                };
                this.setLoading(true);
                vestPraise({
                    data: Object.assign({}, params),
                    success: data => {
                        this.setLoading(false);
                        this.startInfoEvent();
                        this.$message({
                            message: '点赞成功',
                            type: 'success'
                        });
                    },
                    error: data => {
                        this.setLoading(false);
                        console.log('error：', data)
                    }
                })
            },
            // 搜索
            searchClick() {
                this.setLoading(true);
                let searchDate = this.time;
                let params = {
                    starid:this.$route.query.innerid,
                    keyword: this.searchName,
                    filetype:this.integralValue,
                    beginTime:searchDate.date[0]?fecha.format(searchDate.date[0], 'yyyy-MM-dd'):'',
                    endTime:searchDate.date[1]?fecha.format(searchDate.date[1], 'yyyy-MM-dd'):'',
                };
                getStartInfoList({
                    data: Object.assign({}, params, this.page),
                    success: data => {
                        this.setLoading(false);
                        this.StartInfoData = data.data.content;
                        this.total = data.data.pageinfo.rowCount
                    },
                    error: data => {
                        console.log('error：', data);
                        this.setLoading(false)
                    }
                })
            },
        },
        computed: {
            ...mapGetters([
                'page',
                'user'
            ])
        },
    }
</script>

<style scoped lang="scss">
    .topicIndex {
        display: flex;
        flex-direction: column;
    }
    .startMgt-header {
        width: 100%;
        height: 40px;
        margin-bottom: 12px;
        .el-input__icon {
            height: 36px ;
            line-height: 0!important;
        }
        .el-select,.el-select>.el-input,.el-button {
            height: 32px;
        }
        .el-select {
            width: 116px;
        }
        .el-select,.el-input {
            margin-right: 20px;
        }
    }
    .customerBox {
        display: flex;
        align-items: center;
        img {
            width: 50px;
            height: 50px;
            border-radius: 50%;
            margin-right: 10px;
        }
    }
    /*表格操作样式*/
    .table-position {
        white-space: nowrap;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        span {
            color: #409EFF;
            cursor: pointer;
        }
    }
    /*样式更改 日期选择*/
    .el-range-editor.el-input__inner {
        padding: 0 10px;
    }
    .topicIndex .el-date-editor {
        margin-right: 20px;
    }
</style>
